var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    'label',
    ("label--" + _vm.color),
    ("label--" + _vm.variant),
    { 'label--start-icon': _vm.startIcon },
    { 'label--end-icon': _vm.endIcon } ],style:(_vm.sx)},[(_vm.startIcon)?_c('span',{staticClass:"label__icon",domProps:{"innerHTML":_vm._s(_vm.startIcon)}}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.children)+"\n  "),(_vm.endIcon)?_c('span',{staticClass:"label__icon",domProps:{"innerHTML":_vm._s(_vm.endIcon)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }